import type { Resource } from '../../';
export const country_countries_MT: Resource = {"default":"Malta"};
